import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/(core)/my-equipment/error.tsx");
